<script setup lang="ts">
import { usePlayer } from '~/composables/audio/player'
import { useTimeoutFn } from '@vueuse/core'
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { volume, mute } = usePlayer()
const expanded = ref(false)

const { t } = useI18n()
const labels = computed(() => ({
  unmute: t('components.audio.VolumeControl.button.unmute'),
  mute: t('components.audio.VolumeControl.button.mute'),
  slider: t('components.audio.VolumeControl.label.slider')
}))

const { start, stop } = useTimeoutFn(() => (expanded.value = false), 500, { immediate: false })

const handleOver = () => {
  stop()
  expanded.value = true
}

const handleLeave = () => {
  stop()
  start()
}

const scroll = (event: WheelEvent) => {
  volume.value += -Math.sign(event.deltaY) * 0.05
}
</script>

<template>
  <button
    :class="[
      'color-default shape-circle',
      'component-volume-control',
      {'expanded': expanded}
    ]"
    style="border: none"
    ui-block-size="48"
    @click.prevent.stop=""
    @mouseover="handleOver"
    @mouseleave="handleLeave"
    @wheel.stop.prevent="scroll"
  >
    <span
      v-if="volume === 0"
      :role="'button' /*TODO: Refactor to get valid HTML*/"
      :title="labels.unmute"
      :aria-label="labels.unmute"
      @click.prevent.stop="mute"
    >
      <Icon icon="bi:volume-mute-fill" />
    </span>
    <span
      v-else-if="volume < 0.5"
      :role="'button' /*TODO: Refactor to get valid HTML*/"
      :title="labels.mute"
      :aria-label="labels.mute"
      @click.prevent.stop="mute"
    >
      <Icon icon="bi:volume-down-fill" />
    </span>
    <!-- TODO: Replace with HTML `<button>` element for better accessibility -->
    <span
      v-else
      :role="'button' /*TODO: Refactor to get valid HTML*/"
      :title="labels.mute"
      :aria-label="labels.mute"
      @click.prevent.stop="mute"
    >
      <Icon icon="bi:volume-up-fill" />
    </span>
    <div class="popup">
      <label
        for="volume-slider"
        class="visually-hidden"
      >{{ labels.slider }}</label>
      <input
        id="volume-slider"
        v-model="volume"
        type="range"
        step="any"
        min="0"
        max="1"
      >
    </div>
  </button>
</template>
